// extracted by mini-css-extract-plugin
export default {"container":"Option_container__T67nm","title":"Option_title__omiy1","description":"Option_description__XkAC7","disabled":"Option_disabled__3sKsW"};